import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RegbpService } from '../api/src/app/services/regbp.service';
import { concatAll, map, toArray } from 'rxjs/operators';
import { Authorisation } from '../api/src/app/models/REGBP-V1.0.0/authorisation.model';

@Injectable({
  providedIn: 'root'
})
export class AuthorisationFacade {
  constructor(public regbpService: RegbpService) {}

  public getAuthorisations(language: string): Observable<Authorisation[]> {
    return this.regbpService.getAuthorisationList(language).pipe(
      map((results: any) => results.$response.body.items),
      concatAll(),
      map((authorisation: Authorisation) => {
        return authorisation;
      }),
      toArray()
    );
  }
}
